<template>
  <div class="content">
    <el-tabs class="tabLv3" type="border-card" v-model="tabName">
      <i class="lt"></i>
      <i class="rt"></i>
      <el-tab-pane name="spacerBarData">
        <span slot="label">
          <i class="iconfont iconcheck"></i>
          <i class="border"></i>智能间隔棒
        </span>
        <div class="w_normalNav" :parent="self">
          <button class="BlueSmBtn" @click="subSeefrom">搜索</button>
          <button class="OrangeSmBtn" @click="reset">重置</button>
          <downloadBtn
            url="operation/gapStick/export/gapStickData"
            :params="seefrom"
            method="post"
            :needUserId="true"
          ></downloadBtn>
          <button class="GreenSmBtn" @click="openConfigDialog">指令下发</button>
        </div>
        <div class="searchForm1">
          <searchForm :items="items" :formPlus="form_jsgl" ref="searchForm_jsgl">
            <template slot="last">
              <el-form-item label="开始时间" label-width="115px">
                <el-date-picker
                  v-model="seefrom.startTime"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  format="yyyy-MM-dd HH:mm:ss"
                  type="datetime"
                  placeholder="请选择开始时间"
                  style="width: 100%"
                >
                </el-date-picker>
              </el-form-item>
              <el-form-item label="结束时间" label-width="115px">
                <el-date-picker
                  v-model="seefrom.endTime"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  format="yyyy-MM-dd HH:mm:ss"
                  type="datetime"
                  placeholder="请选择结束时间"
                  style="width: 100%"
                >
                </el-date-picker>
              </el-form-item>
              <el-form-item label="设备编号">
                <el-input v-model="seefrom.deviceId" placeholder="请输入设备编号"></el-input>
              </el-form-item>
              <el-form-item label="线路编号">
                <el-input v-model="seefrom.line" placeholder="请输入线路编号"></el-input>
              </el-form-item>
              <br />
              <el-form-item label="主机状态" label-width="115px">
                <el-select
                  :popper-append-to-body="false"
                  v-model="seefrom.status"
                  placeholder="请选择主机状态"
                  clearable
                >
                  <el-option
                    v-for="(item, index) in statusList"
                    :key="index"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </template>
          </searchForm>
        </div>
        <div class="tableWrapper">
          <el-table
            :data="tableData"
            style="width: 100%"
            class="stripeTable"
            height="500"
            ref="Table"
          >
            <el-table-column
              show-overflow-tooltip
              :label="label"
              :prop="prop"
              :align="align"
              :width="width"
              v-for="{ prop, label, align, width } in config"
              :key="prop.toString()"
            ></el-table-column>
            <el-table-column prop="deviceStatus" label="设备状态">
              <template slot-scope="scope">
                {{ scope.row.deviceStatus == 1 ? '报警' : '正常' }}
              </template>
            </el-table-column>
            <el-table-column label="操作" width="170">
              <template slot-scope="scope">
                <el-link
                  icon="iconfont iconcheck"
                  type="text"
                  size="small"
                  @click="check(scope.row)"
                  >详情
                </el-link>
              </template>
            </el-table-column>
          </el-table>
          <div class="footer">
            <el-pagination
              layout="prev, pager, next"
              :page-size="10"
              @current-change="handleCurrentChange"
              :total="nTotal"
              :current-page="currentPage"
            >
            </el-pagination>
          </div>
        </div>
      </el-tab-pane>
      <el-dialog :visible.sync="detailDialog" class="cust_dialog editDialog" title="详情">
        <el-form
          :model="detail"
          class="addDetail"
          ref="detail"
          label-suffix="："
          style="margin: 0 40px 0 20px;"
        >
          <el-form-item label="记录时间" prop="sendTime">
            <p>{{ detail.sendTime }}</p>
          </el-form-item>
          <el-form-item label="设备编码" prop="deviceId">
            <p>{{ detail.deviceId }}</p>
          </el-form-item>
          <el-form-item label="设备名称" prop="deviceName">
            <p>{{ detail.deviceName }}</p>
          </el-form-item>
          <el-form-item label="设备类型" prop="deviceTypeName">
            <p>{{ detail.deviceTypeName }}</p>
          </el-form-item>
          <el-form-item label="定位经度" prop="longitude">
            <p>{{ detail.longitude }}</p>
          </el-form-item>
          <el-form-item label="定位纬度" prop="latitude">
            <p>{{ detail.latitude }}</p>
          </el-form-item>
          <el-form-item label="主机电量" prop="electric">
            <p>{{ detail.electric }}</p>
          </el-form-item>
          <el-form-item label="通讯质量" prop="dbm">
            <p>{{ detail.dbm }}</p>
          </el-form-item>
          <el-form-item label="偏磁感应" prop="magnetic">
            <p>{{ detail.magnetic }}</p>
          </el-form-item>
          <el-form-item label="环境温度" prop="temperature">
            <p>{{ detail.temperature }}</p>
          </el-form-item>
          <el-form-item label="环境湿度" prop="humidity">
            <p>{{ detail.humidity }}</p>
          </el-form-item>
          <el-form-item label="舞动幅度" prop="scope">
            <p>{{ detail.scope }}</p>
          </el-form-item>
          <el-form-item label="舞动频率" prop="frequency">
            <p>{{ detail.frequency }}</p>
          </el-form-item>
          <el-form-item label="主机状态" prop="status">
            <p>{{ detail.deviceStatus == 1 ? '报警' : '正常' }}</p>
          </el-form-item>
          <div v-for="(item, index) in detail.subDataList" :key="index">
            <el-form-item :label="item.line + '电流'" :prop="item.currentValue">
              <p>{{ item.currentValue }}</p>
            </el-form-item>
            <el-form-item :label="item.line + '温度'" :prop="item.temperature">
              <p>{{ item.temperature }}</p>
            </el-form-item>
            <el-form-item :label="item.line + '状态'" :prop="item.status">
              <p>{{ item.status == 1 ? '报警' : '正常' }}</p>
            </el-form-item>
            <el-form-item :label="item.line + '线夹状态'" :prop="item.dropInfo">
              <p>{{ item.dropInfo == 1 ? '脱落' : item.dropInfo == 0 ? '正常' : '' }}</p>
            </el-form-item>
            <el-form-item
              :label="item.line + '偏磁'"
              :prop="item.magnetic"
              v-if="detail.deviceName.indexOf('DC') != -1"
            >
              <p>{{ item.magnetic }}</p>
            </el-form-item>
          </div>
        </el-form>
      </el-dialog>
    </el-tabs>
    <configDialog :visible.sync="configDialogVisible" @confirm="handleConfirm"></configDialog>
  </div>
</template>

<script>
  import { date } from 'utils'
  import configDialog from './configDialog'
  export default {
    name: 'spacerBarData',
    data() {
      return {
        form_jsgl: {},
        items: [],
        statusList: [
          {
            label: '正常',
            value: 0
          },
          {
            label: '报警',
            value: 1
          }
        ],
        tabName: 'spacerBarData',
        seefrom: {},
        tableData: [],
        nTotal: 0,
        currentPage: 1,
        currentSize: 10,
        detailDialog: false,
        detail: {},
        configDialogVisible: false
      }
    },
    computed: {
      self() {
        return this
      },
      config() {
        return [
          {
            prop: 'sendTime',
            label: '记录时间'
          },
          {
            prop: 'deviceId',
            label: '设备编码'
          },
          {
            prop: 'deviceName',
            label: '设备名称'
          },
          {
            prop: 'deviceTypeName',
            label: '设备类型'
          },
          {
            prop: 'temperature',
            label: '环境温度'
          },
          {
            prop: 'humidity',
            label: '环境湿度'
          },
          {
            prop: 'scope',
            label: '舞动幅度'
          },
          {
            prop: 'electric',
            label: '主机电量'
          }
        ]
      }
    },
    components: {
      normalNav: () => import('public/normalNav'),
      searchForm: () => import('public/searchForm'),
      easyTable: () => import('public/easyTable'),
      downloadBtn: () => import('public/download'),
      configDialog
    },
    methods: {
      //搜索
      subSeefrom() {
        this.currentPage = 1
        this.getTableData()
      },
      //重置
      reset() {
        this.seefrom = {}
      },
      handleCurrentChange(val) {
        this.currentPage = val
        this.getTableData()
      },
      // 每页数
      sizeChangeHandle(val) {
        this.currentSize = val
        this.currentPage = 1
        this.getTableData()
      },
      isMaxGtMin() {
        if (!this.seefrom.startTime || !this.seefrom.endTime) return true
        let ns = new Date(this.seefrom.startTime).getTime()
        let ne = new Date(this.seefrom.endTime).getTime()
        return ne > ns ? true : false
      },
      //查询表格数据
      getTableData() {
        if (this.seefrom.startTime && this.seefrom.endTime) {
          if (!this.isMaxGtMin()) {
            this.$notify({
              message: '开始时间需小于结束时间',
              type: 'warning'
            })
            return
          }
        }
        this.$axiosget('operation/gapStick/getPage', {
          params: {
            pageSize: this.currentSize,
            pageNum: this.currentPage,
            ...this.seefrom,
            startTime: this.seefrom.startTime ? this.seefrom.startTime : undefined,
            endTime: this.seefrom.endTime ? this.seefrom.endTime : undefined
          }
        }).then(res => {
          this.tableData = res.data.data.list
          this.nTotal = res.data.data.total
        })
      },
      changeTab(val) {
        this.activeName = val
      },
      check(row) {
        this.$axiosget('operation/gapStick/getPageDetail', {
          params: {
            id: row.id
          }
        }).then(res => {
          this.detail = res.data.data
          this.detailDialog = true
        })
      },
      openConfigDialog() {
        this.configDialogVisible = true
      },
      handleConfirm(result) {
        console.log(result)
        this.$axiospost(`operation/gapStick/updateOrder?deviceId=${result.deviceCode}`, {
          ...result.data,
          sendFrequency: result.data.sendFrequency ? Number(result.data.sendFrequency) : undefined
        }).then(res => {
          if (res.data.status == 10000) {
            this.$message({
              message: '操作成功',
              type: 'success'
            })
            this.configDialogVisible = false
          }
        })
      }
    },
    created() {
      this.getTableData()
    }
  }
</script>

<style lang="less">
  .w_normalNav {
    padding-top: 10px;
    height: 52px;
    position: absolute;
    top: -52px;
    right: 32px;
    z-index: 99;
  }
  .el-input__inner:focus {
    border: 1px solid #3587c7;
  }
</style>

<style lang="less" scoped>
  .cust_dialog /deep/ .el-dialog__body {
    padding-top: 35px;
  }
  .cust_dialog {
    /deep/ .el-form-item__content {
      margin-left: 0 !important;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/dynamicRoute3/management/spaceBarData/index.vue